module.exports = __webpack_public_path__ + "img/133_thumbnail.2b420ff4.jpg";